const emailCapture = () => {
  let checkbox = document.getElementById('send_newsletter');
  const hiddenCheckboxes = document.querySelectorAll('input[type="hidden"]');

  if (hiddenCheckboxes) {
    const hiddenCheckbox = [...hiddenCheckboxes].filter(
      hiddenCheckbox => hiddenCheckbox.value === 'newsletter_subscribed'
    )[0];

    if (checkbox && hiddenCheckbox) {
      checkbox.addEventListener('change', () => {
        if (checkbox.checked) {
          hiddenCheckbox.value += ', manages_office_beverages';
        } else {
          hiddenCheckbox.value = 'newsletter_subscribed';
        }
      });
    }
  }
};

export default emailCapture;
